export default __webpack_public_path__ + "static/media/题库.f7b97fb0.png";